"use strict";
/**
 * =================================
 * breakpoint 設定
 * =================================
 */
const screens = {
    lg: '1024px',
    md: '768px',
    sm: '640px',
    xl: '1280px',
    xs: '375px',
    xxs: '320px',
};
module.exports = {
    screens,
};
